import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: localStorage.getItem("user_token") || null,
    user: JSON.parse(localStorage.getItem("user_data") || "{}"),
  }),
  getters: {
    isAuthenticated(state) {
      return !!state.token;
    },
    userRole(state) {
      return state.user?.role || null;
    },
    isAdmin(state) {
      const role = state.user?.role?.toLowerCase();
      return role === "admin" || role === "super-admin";
    },
    isSuperAdmin(state) {
      return state.user?.role?.toLowerCase() === "super-admin";
    },
    permissions(state) {
      return state.user?.permissions || [];
    },
  },
  actions: {
    setAuth({ token, user }) {
      this.token = token;
      this.user = user;
      localStorage.setItem("user_token", token);
      localStorage.setItem("user_data", JSON.stringify(user || {}));
    },
    clearAuth() {
      this.token = null;
      this.user = {};
      localStorage.removeItem("user_token");
      localStorage.removeItem("user_data");
      sessionStorage.removeItem("announce_session_shown");
    },
    hasPermission(permission) {
      return this.permissions.includes(permission);
    },
  },
});
